import { useInjection } from 'inversify-react';

import { Button, Slider } from '@desygner/ui-common-components';

import { VideoManager } from '../../../../../core/viewer/video-manager';
import { TYPES } from '../../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../../store';
import { isIOS } from '../../../../../utils/device.util';
import { StyledVolumeWrapper } from './Volume.styles';

export const Volume = () => {
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const videoManager = useInjection<VideoManager>(TYPES.Viewer.VideoManager);
  const currentPlayingMedia = useViewerStore((state) => state.currentPlayingMedia);

  if (currentPlayingMedia?.volume == undefined) return null;

  const isVideoMuted = currentPlayingMedia.volume === 0;
  const isIOSDevice = isIOS();

  return (
    <StyledVolumeWrapper>
      <Button
        icon={{
          name: isVideoMuted ? 'video-mute' : 'video-unmute',
        }}
        size="Small"
        variant="ghost"
        onClick={videoManager.handleMuteVolume}
        action="navigation-page"
        dataset={{
          direction: 'previous',
        }}
      />
      {!isIOSDevice && (
        <Slider
          data-testid="video-volume-slider"
          name="volume"
          step={5}
          value={currentPlayingMedia.volume * 100}
          onChange={videoManager.handleVideoVolumeChange}
          min={0}
          max={100}
        />
      )}
    </StyledVolumeWrapper>
  );
};
